import { BaseProps } from '../../common/BaseProps';
import styles from './Message.module.css';

interface Props extends BaseProps {
  type?: string;
  title?: any;
  text?: any;
  textBold?: boolean;
};

const Message: React.FC<Props> = (props) => {
  const { type = 'info' } = props;

  const getIcon = () => {
    switch (type) {
      case 'info': return 'fas fa-info-circle';
      case 'success': return 'fas fa-check-circle';
      case 'warning': return 'fas fa-exclamation-triangle';
      case 'error': return 'fas fa-times-circle';
      case 'question': return 'fas fa-question';
    }
  };

  return (
    <div
      className={`${styles.container} ${styles[type]} ${props.className ? props.className : ''}`}
      style={props.style}
      onClick={props.onClick}
    >
      <div className={`${styles.titleWrapper} ${!props.title ? styles.secondary : ''}`}>
        <i className={`${getIcon()} ${styles.icon} ${styles[type]}`}></i>
        {props.title && <span className={styles.title}>{props.title}</span>}
        {!props.title && props.text && (
          <div className={props.textBold ? styles.secondaryTextBold : styles.secondaryText}>
            <span>{props.text}</span>
          </div>
        )}
      </div>
      {props.title && props.text && props.textBold && <span className={`${props.textBold ? styles.secondaryTextBold : styles.secondaryText} ${styles.content}`}>{props.text}</span>}
      {props.title && props.text && !props.textBold && <span className={styles.content}>{props.text}</span>}
    </div>
  );
};

export default Message;
